import React from "react";

interface TypeformNavigationProps {
  onNext: () => void;
  onBack: () => void;
  canGoBack: boolean;
  canGoNext: boolean;
  isLastPage: boolean;
  isSubmitting: boolean;
}

export default function TypeformNavigation({
  onNext,
  onBack,
  canGoBack,
  canGoNext,
  isLastPage,
  isSubmitting,
}: TypeformNavigationProps) {
  return (
    <div className="flex items-center gap-4 mt-10">
      {canGoBack && (
        <button
          onClick={onBack}
          className="px-6 py-3 rounded-xl border-2 border-gray-200 text-gray-700 font-medium hover:border-pista-700 hover:text-pista-700 transition-colors duration-200 bg-white"
          type="button"
        >
          Back
        </button>
      )}
      <button
        onClick={onNext}
        disabled={!canGoNext || isSubmitting}
        className={`px-8 py-3 rounded-xl font-semibold text-white transition-all duration-200 ${
          canGoNext && !isSubmitting
            ? "bg-pista-700 hover:bg-pista-800 shadow-lg hover:shadow-xl"
            : "bg-gray-300 cursor-not-allowed"
        }`}
        type="button"
      >
        {isSubmitting
          ? "Submitting..."
          : isLastPage
          ? "Submit"
          : "Next"}
      </button>
    </div>
  );
}
